import { render, staticRenderFns } from "./WarehouseAreaList.vue?vue&type=template&id=344ab603&"
import script from "./WarehouseAreaList.vue?vue&type=script&lang=js&"
export * from "./WarehouseAreaList.vue?vue&type=script&lang=js&"
import style0 from "./WarehouseAreaList.vue?vue&type=style&index=0&id=344ab603&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports